import { render, staticRenderFns } from "./SnakeGame1.vue?vue&type=template&id=732265a8&scoped=true&"
import script from "./SnakeGame1.vue?vue&type=script&lang=js&"
export * from "./SnakeGame1.vue?vue&type=script&lang=js&"
import style0 from "./SnakeGame1.vue?vue&type=style&index=0&id=732265a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732265a8",
  null
  
)

export default component.exports